(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[9391],{

/***/ 90927:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: () => (/* binding */ init)
/* harmony export */ });
/* harmony import */ var _sentry_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(469);
/* harmony import */ var _sentry_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92619);


/**
 * Inits the React SDK
 */
function init(options) {
  options._metadata = options._metadata || {};
  options._metadata.sdk = options._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: _sentry_browser__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .M,
      },
    ],
    version: _sentry_browser__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .M,
  };
  (0,_sentry_browser__WEBPACK_IMPORTED_MODULE_1__/* .init */ .Ts)(options);
}


//# sourceMappingURL=sdk.js.map


/***/ }),

/***/ 4674:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var reactIs = __webpack_require__(17020);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 17462:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(95271),
    isArray = __webpack_require__(25874),
    isObjectLike = __webpack_require__(77583);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 84341:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 68689:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: () => (/* binding */ Link),
/* harmony export */   p: () => (/* binding */ isInternalURL)
/* harmony export */ });
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12495);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64234);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81724);
/* harmony import */ var _icons_ExternalLinkIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22228);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36129);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83712);





const base = typeof window !== "undefined" ? new URL(`${window.location.protocol}//${window.location.host}`) : new URL("https://app.gadget.dev");
function isInternalURL(url) {
    try {
        return new URL(url, base).hostname === base.hostname;
    } catch (error) {
        return true;
    }
}
const Link = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((props, ref)=>{
    const internal = props.external ? false : isInternalURL(props.href);
    const overrides = lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({
        BaseButton: {
            style: ({ $theme })=>{
                return {
                    paddingLeft: "0px",
                    paddingRight: "0px",
                    paddingTop: props.compact ? "0px" : undefined,
                    paddingBottom: props.compact ? "0px" : undefined,
                    fontSize: "inherit",
                    fontWeight: "inherit",
                    fontFamily: "inherit",
                    whiteSpace: "no-wrap",
                    color: "inherit",
                    textDecoration: "underline",
                    ":hover:not(:disabled)": {
                        color: "inherit"
                    },
                    ":hover:not(:disabled):not(:active)": {
                        color: "inherit"
                    },
                    ":focus-visible": {
                        color: "inherit",
                        outlineOffset: "3px"
                    },
                    ":disabled": {
                        color: $theme.colors.alpha400,
                        backgroundColor: "transparent"
                    },
                    ":active:not(:disabled)": {
                        color: "inherit",
                        // This is a hack to disable the button's default transform because we set the button as <a/> and it doesn't have the "disabled" HTML attribute
                        transform: props.disabled ? "" : "perspective(500px) translate3d(0, 0, -20px)"
                    }
                };
            }
        },
        EndEnhancer: {
            style: {
                marginLeft: "4px"
            }
        }
    }, props.overrides);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .$n, {
        ref: ref,
        kind: _Button__WEBPACK_IMPORTED_MODULE_3__/* .ButtonKind */ .ZN.tertiary,
        $as: "a",
        target: internal ? undefined : "_blank",
        endEnhancer: props.endEnhancer ?? internal ? null : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_icons_ExternalLinkIcon__WEBPACK_IMPORTED_MODULE_4__/* .ExternalLinkIcon */ .p, {
            $size: props.size == _Button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .SK.compact ? 12 : 16
        }),
        ...lodash_omit__WEBPACK_IMPORTED_MODULE_1___default()(props, [
            "compact"
        ]),
        overrides: overrides
    });
});


/***/ }),

/***/ 62783:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   aF: () => (/* binding */ Modal),
/* harmony export */   cw: () => (/* binding */ ModalBody),
/* harmony export */   rQ: () => (/* binding */ ModalHeader)
/* harmony export */ });
/* unused harmony exports ModalFooter, CloseButton */
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89944);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78803);
/* harmony import */ var baseui_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65872);
/* harmony import */ var baseui_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16581);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);
/* harmony import */ var _icons_CloseIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30211);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72919);
/* harmony import */ var _button_PlainButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93189);







const ModalHeader = (props)=>{
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalHeader */ .rQ, {
        $as: "header",
        ...props,
        $style: {
            ...$theme.typography.subHeading,
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .expandMargin */ .RJ)($theme.sizing.scale600),
            ...props.$style
        }
    });
};
const ModalBody = (props)=>{
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalBody */ .cw, {
        $as: "section",
        ...props,
        $style: {
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .expandMargin */ .RJ)($theme.sizing.scale600),
            color: $theme.colors.contentPrimary,
            ...props.$style
        }
    });
};
const ModalFooter = (props)=>{
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalFooter */ .jl, {
        $as: "footer",
        ...props,
        $style: {
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .expandMargin */ .RJ)($theme.sizing.scale600),
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .paddingVertical */ .kx)(0),
            display: "flex",
            gap: $theme.sizing.scale500,
            justifyContent: "end",
            alignItems: "center",
            ...props.$style
        }
    });
};
const Modal = (props)=>{
    const [css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    const overrides = (0,baseui__WEBPACK_IMPORTED_MODULE_4__/* .mergeOverrides */ .Qp)({
        Close: {
            component: CloseButton,
            style: {
                position: "absolute",
                top: $theme.sizing.scale600,
                right: $theme.sizing.scale600
            }
        },
        Dialog: {
            props: {
                "data-testid": props["data-testid"]
            },
            style: {
                ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .expandBorderRadii */ .iw)("8px"),
                boxShadow: $theme.lighting.depth4
            }
        }
    }, props.overrides);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A, {
        unstable_ModalBackdropScroll: true,
        ...props,
        overrides: overrides
    }, props.raw ? props.children : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, props.title && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalHeader, {
        $style: overrides.ModalHeader?.style
    }, props.title), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalBody, {
        $style: overrides.ModalBody?.style
    }, props.children), (props.footer || props.footerLeft) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalFooter, null, props.footerLeft && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: css({
            marginRight: "auto"
        })
    }, props.footerLeft), props.footer)));
};
const CloseButton = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_button_PlainButton__WEBPACK_IMPORTED_MODULE_6__/* .PlainButton */ .p, {
        type: "button",
        ...props,
        $style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            ...props.$style
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icons_CloseIcon__WEBPACK_IMPORTED_MODULE_7__/* .CloseIcon */ .U, null));


/***/ }),

/***/ 29837:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: () => (/* binding */ AccordionExpandIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89944);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50182);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64234);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81724);




const AccordionExpandIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_2__/* .useStyletron */ .c6)();
    let rotation = 0;
    if (props.direction == "down") {
        rotation = 90;
    } else if (props.direction == "left") {
        rotation = 180;
    } else if (props.direction == "up") {
        rotation = -90;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_3__/* .Svg */ .B, {
        viewBox: "0 0 30 30",
        ...lodash_omit__WEBPACK_IMPORTED_MODULE_0___default()(props, [
            "direction",
            "$style"
        ]),
        $style: {
            transformOrigin: "center",
            transform: `rotate(${rotation}deg)`,
            ...props.$style
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
        d: "M20.625 15.0001C20.625 15.1974 20.5494 15.3948 20.3991 15.5451L12.6908 23.2534C12.4704 23.4738 12.1389 23.5401 11.8506 23.4207C11.5623 23.3019 11.375 23.0198 11.375 22.7084V7.29179C11.375 6.98037 11.5623 6.69825 11.8506 6.57954C12.1389 6.46006 12.4704 6.52635 12.6908 6.74681L20.3991 14.4551C20.5494 14.6054 20.625 14.8028 20.625 15.0001Z",
        fill: "currentColor"
    }));
};


/***/ }),

/***/ 87823:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   y: () => (/* binding */ CircleCheckIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89944);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);



const CircleCheckIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_2__/* .Svg */ .B, {
        viewBox: "0 0 12 12",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
        cx: "6",
        cy: "6",
        r: "6",
        fill: props.backgroundColor ?? "white"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M6 1.83333C8.2975 1.83333 10.1667 3.7025 10.1667 6C10.1667 8.2975 8.2975 10.1667 6 10.1667C3.7025 10.1667 1.83333 8.2975 1.83333 6C1.83333 3.7025 3.7025 1.83333 6 1.83333ZM6 1C3.23875 1 1 3.23875 1 6C1 8.76125 3.23875 11 6 11C8.76125 11 11 8.76125 11 6C11 3.23875 8.76125 1 6 1ZM7.83042 4.125L5.47917 6.535L4.3775 5.49083L3.60417 6.265L5.47917 8.08333L8.60417 4.89875L7.83042 4.125Z",
        fill: props.color ?? $theme.colors.positive
    }));
};


/***/ }),

/***/ 22228:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   p: () => (/* binding */ ExternalLinkIcon)
/* harmony export */ });
/* unused harmony export ExternalLinkIconBox */
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);


// Arrow pointing through the top right corner of a square outline
const ExternalLinkIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .B, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M13.653 1.66042C13.6284 1.66123 13.6038 1.66341 13.5794 1.66693H9.33268C9.24434 1.66568 9.15663 1.68201 9.07465 1.71495C8.99267 1.74789 8.91806 1.7968 8.85515 1.85883C8.79223 1.92086 8.74228 1.99477 8.70818 2.07628C8.67408 2.15778 8.65652 2.24525 8.65652 2.3336C8.65652 2.42195 8.67408 2.50942 8.70818 2.59092C8.74228 2.67243 8.79223 2.74634 8.85515 2.80837C8.91806 2.8704 8.99267 2.91931 9.07465 2.95225C9.15663 2.9852 9.24434 3.00152 9.33268 3.00027H12.0566L7.528 7.52891C7.46401 7.59034 7.41293 7.66392 7.37774 7.74534C7.34255 7.82676 7.32396 7.91438 7.32305 8.00308C7.32215 8.09177 7.33896 8.17975 7.37248 8.26187C7.40601 8.34399 7.45558 8.4186 7.5183 8.48131C7.58102 8.54403 7.65562 8.59361 7.73774 8.62713C7.81986 8.66066 7.90785 8.67746 7.99654 8.67656C8.08523 8.67566 8.17286 8.65707 8.25427 8.62188C8.33569 8.58669 8.40927 8.5356 8.4707 8.47162L12.9993 3.94298V6.66693C12.9981 6.75528 13.0144 6.84298 13.0474 6.92496C13.0803 7.00694 13.1292 7.08156 13.1912 7.14447C13.2533 7.20738 13.3272 7.25734 13.4087 7.29144C13.4902 7.32554 13.5777 7.3431 13.666 7.3431C13.7544 7.3431 13.8418 7.32554 13.9233 7.29144C14.0048 7.25734 14.0788 7.20738 14.1408 7.14447C14.2028 7.08156 14.2517 7.00694 14.2847 6.92496C14.3176 6.84298 14.3339 6.75528 14.3327 6.66693V2.41563C14.3455 2.31985 14.3374 2.22241 14.3089 2.13007C14.2804 2.03774 14.2321 1.9527 14.1675 1.88087C14.1028 1.80903 14.0233 1.75211 13.9345 1.71405C13.8456 1.67598 13.7496 1.65769 13.653 1.66042ZM4.16602 2.66693C2.79358 2.66693 1.66602 3.7945 1.66602 5.16693V11.8336C1.66602 13.206 2.79358 14.3336 4.16602 14.3336H10.8327C12.2051 14.3336 13.3327 13.206 13.3327 11.8336V8.66693C13.3339 8.57859 13.3176 8.49088 13.2847 8.40891C13.2517 8.32693 13.2028 8.25231 13.1408 8.1894C13.0788 8.12649 13.0048 8.07653 12.9233 8.04243C12.8418 8.00833 12.7544 7.99077 12.666 7.99077C12.5777 7.99077 12.4902 8.00833 12.4087 8.04243C12.3272 8.07653 12.2533 8.12649 12.1912 8.1894C12.1292 8.25231 12.0803 8.32693 12.0474 8.40891C12.0144 8.49088 11.9981 8.57859 11.9993 8.66693V11.8336C11.9993 12.4825 11.4816 13.0003 10.8327 13.0003H4.16602C3.51712 13.0003 2.99935 12.4825 2.99935 11.8336V5.16693C2.99935 4.51804 3.51712 4.00027 4.16602 4.00027H7.33268C7.42102 4.00152 7.50873 3.9852 7.59071 3.95225C7.67269 3.91931 7.7473 3.8704 7.81022 3.80837C7.87313 3.74634 7.92309 3.67243 7.95719 3.59092C7.99128 3.50942 8.00884 3.42195 8.00884 3.3336C8.00884 3.24525 7.99128 3.15778 7.95719 3.07628C7.92309 2.99477 7.87313 2.92086 7.81022 2.85883C7.7473 2.7968 7.67269 2.74789 7.59071 2.71495C7.50873 2.68201 7.42102 2.66568 7.33268 2.66693H4.16602Z"
    }));
// Solid colored box with an internal arrow pointing to top right corner
const ExternalLinkIconBox = (props)=>/*#__PURE__*/ React.createElement(StyledSvg, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12.1667 2H3.83333C2.82233 2 2 2.82267 2 3.83333V12.1667C2 13.1773 2.82233 14 3.83333 14H12.1667C13.1777 14 14 13.1773 14 12.1667V3.83333C14 2.82267 13.1777 2 12.1667 2ZM12 8.16667C12 8.44267 11.7763 8.66667 11.5 8.66667C11.2237 8.66667 11 8.44267 11 8.16667V5.707L5.85367 10.8537C5.756 10.9513 5.628 11 5.5 11C5.372 11 5.244 10.9513 5.14633 10.8537C4.951 10.6583 4.951 10.342 5.14633 10.1467L10.293 5H7.83333C7.557 5 7.33333 4.776 7.33333 4.5C7.33333 4.224 7.557 4 7.83333 4H11.5C11.7763 4 12 4.224 12 4.5V8.16667Z"
    })));


/***/ }),

/***/ 28524:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  V: () => (/* binding */ GadgetLogoMark),
  w: () => (/* binding */ GadgetLogoType)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(81724);
;// ../@gadgetinc/widgets/assets/logomark.svg
/* harmony default export */ const logomark = (__webpack_require__.p + "1b5b906861f70ec70ea51c35c1e023be.svg");
;// ../@gadgetinc/widgets/assets/logotype.svg
/* harmony default export */ const logotype = (__webpack_require__.p + "13513703c5b41ce947547e20671b9409.svg");
;// ../@gadgetinc/widgets/src/icons/GadgetLogo.tsx



const GadgetLogoType = (props)=>{
    return /*#__PURE__*/ react.createElement("img", {
        ...props,
        src: logotype
    });
};
const GadgetLogoMark = (props)=>{
    return /*#__PURE__*/ react.createElement("img", {
        ...props,
        src: logomark
    });
};


/***/ }),

/***/ 36205:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i: () => (/* binding */ MonoBody),
/* harmony export */   n: () => (/* binding */ Body)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89944);

const Body = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .I4)("p", ({ $theme })=>({
        ...$theme.typography.body,
        color: $theme.colors.contentPrimary
    }));
const MonoBody = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .I4)("p", ({ $theme })=>({
        ...$theme.typography.MonoLabelMedium,
        color: $theme.colors.contentPrimary
    }));


/***/ }),

/***/ 4516:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: () => (/* binding */ PageTitle)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89944);

const PageTitle = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .I4)("h1", ({ $theme })=>({
        ...$theme.typography.title,
        color: $theme.colors.contentPrimary
    }));


/***/ }),

/***/ 27937:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D: () => (/* binding */ Heading)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89944);

const Heading = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .I4)("h1", ({ $theme })=>({
        ...$theme.typography.heading,
        color: $theme.colors.contentPrimary
    }));


/***/ }),

/***/ 57142:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: () => (/* binding */ CenteredSpin)
/* harmony export */ });
/* unused harmony export DelayedCenteredSpin */
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89944);
/* harmony import */ var baseui_spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8928);
/* harmony import */ var baseui_spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60307);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);



/** Renders a spinner that centers itself horizontally and vertically in the parent container */ const CenteredSpin = (props)=>{
    const [css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: css({
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        })
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: css({
            paddingLeft: $theme.sizing.scale600,
            paddingRight: $theme.sizing.scale600,
            paddingTop: $theme.sizing.scale600,
            paddingBottom: $theme.sizing.scale600,
            display: "flex",
            flexDirection: "column",
            gap: $theme.sizing.scale600,
            alignItems: "center",
            justifyContent: "center"
        })
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_spinner__WEBPACK_IMPORTED_MODULE_2__/* .StyledSpinnerNext */ .Mg, {
        $size: baseui_spinner__WEBPACK_IMPORTED_MODULE_3__/* .SIZE */ .S.large
    }), props?.children));
};
const DelayedCenteredSpin = (props)=>{
    const [showSpinner, setShowSpinner] = useState(false);
    const delay = props.delay ?? 0;
    useEffect(()=>{
        const timer = setTimeout(()=>{
            setShowSpinner(true);
        }, delay ?? 0);
        return ()=>clearTimeout(timer);
    }, [
        delay
    ]);
    return showSpinner ? /*#__PURE__*/ React.createElement(CenteredSpin, null) : null;
};


/***/ }),

/***/ 57907:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: () => (/* binding */ DebugDisplay),
/* harmony export */   n: () => (/* binding */ ErrorDisplay)
/* harmony export */ });
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68689);
/* harmony import */ var _gadgetinc_widgets_src_EditTheme__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29196);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15318);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89944);
/* harmony import */ var baseui_typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92908);
/* harmony import */ var fast_safe_stringify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18844);
/* harmony import */ var fast_safe_stringify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(fast_safe_stringify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27621);
/* harmony import */ var lodash_isError__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isError__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17462);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81724);
/* harmony import */ var state_trees_src_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73895);











const ReactJson = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Ay)({
    resolved: {},
    chunkName () {
        return "react18-json-view";
    },
    isReady (props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: ()=>Promise.all(/* import() | react18-json-view */[__webpack_require__.e(4258), __webpack_require__.e(528)]).then(__webpack_require__.bind(__webpack_require__, 34258)),
    requireAsync (props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then((resolved)=>{
            this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync (props) {
        const id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval('module.require')(id);
    },
    resolve () {
        if (true) {
            return /*require.resolve*/(34258);
        }
        return eval('require.resolve')("react18-json-view");
    }
});
const Pre = (0,baseui__WEBPACK_IMPORTED_MODULE_7__/* .styled */ .I4)("pre", ({ $theme })=>({
        fontFamily: _gadgetinc_widgets_src_EditTheme__WEBPACK_IMPORTED_MODULE_8__/* .monoFontFamily */ .DE,
        overflow: "auto",
        paddingLeft: $theme.sizing.scale300,
        paddingRight: $theme.sizing.scale300,
        paddingTop: $theme.sizing.scale300,
        paddingBottom: $theme.sizing.scale300,
        marginBottom: $theme.sizing.scale400,
        borderRadius: $theme.borders.radius200
    }));
const ErrorDisplay = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_7__/* .useStyletron */ .c6)();
    let output = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(Pre, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(baseui_typography__WEBPACK_IMPORTED_MODULE_9__/* .Label3 */ .u3, {
        $style: {
            color: $theme.colors.negative500
        }
    }, (0,state_trees_src_utils__WEBPACK_IMPORTED_MODULE_6__/* .errorMessage */ .gJ)(props.error)), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(baseui_typography__WEBPACK_IMPORTED_MODULE_9__/* .Label4 */ .Bz, {
        $style: {
            color: $theme.colors.negative500
        }
    }, "stack" in props.error ? props.error.stack : "<stack unknown>"), props.extra && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(DebugDisplay, {
        data: props.extra
    }));
    if (props.error.graphQLErrors) {
        const errorWithRemedy = lodash_find__WEBPACK_IMPORTED_MODULE_2___default()(props.error.graphQLErrors, "extensions.remedy");
        if (errorWithRemedy) {
            // This can't be null given the above `find` can only give us a truthy value if it is set
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const remedy = errorWithRemedy.extensions.remedy;
            output = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(react__WEBPACK_IMPORTED_MODULE_5__.Fragment, null, output, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .N, {
                href: remedy.href
            }, remedy.text));
        }
    }
    return output;
};
const DebugDisplay = (props)=>{
    const [css] = (0,baseui__WEBPACK_IMPORTED_MODULE_7__/* .useStyletron */ .c6)();
    let output;
    if (lodash_isError__WEBPACK_IMPORTED_MODULE_3___default()(props.data)) {
        output = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(ErrorDisplay, {
            error: props.data
        });
    } else {
        let jsonString;
        try {
            if (lodash_isString__WEBPACK_IMPORTED_MODULE_4___default()(props.data)) {
                output = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement("code", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement("pre", null, props.data));
            } else {
                let json;
                if (props.data) {
                    jsonString = fast_safe_stringify__WEBPACK_IMPORTED_MODULE_1___default()(Object.prototype.hasOwnProperty.call(props.data, "toJSON") ? props.data.toJSON() : props.data);
                    json = JSON.parse(jsonString ?? "{}");
                } else {
                    json = String(props.data);
                }
                output = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(ReactJson, {
                    src: json,
                    collapsed: 2,
                    collapseStringsAfterLength: 100
                });
            }
        } catch (e) {
            output = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(ErrorDisplay, {
                error: e,
                extra: {
                    json: jsonString
                }
            });
        }
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", {
        className: css({
            maxWidth: "1000px",
            ...props.$style
        })
    }, output);
};


/***/ }),

/***/ 38683:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  H: () => (/* binding */ ErrorNavBar),
  M: () => (/* binding */ NotFound)
});

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Column.tsx
var Column = __webpack_require__(15530);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Row.tsx
var Row = __webpack_require__(79638);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/button/Button.tsx
var Button = __webpack_require__(36129);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/GadgetLogo.tsx + 2 modules
var GadgetLogo = __webpack_require__(28524);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(89944);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(81724);
;// ./src/components/MarketingButton.tsx


const MarketingButton = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    return /*#__PURE__*/ react.createElement("button", {
        onClick: props.onClick,
        className: css({
            cursor: "pointer",
            display: "inline-block",
            WebkitBoxPack: "start",
            justifyContent: "flex-start",
            flexWrap: "nowrap",
            alignItems: "center",
            border: "2px solid #2525cf",
            borderRadius: "6px",
            transition: "150ms",
            fontFamily: "Inconsolata,monospace",
            textAlign: "left",
            backgroundColor: "#e2e2e2",
            color: "#0b171e",
            borderColor: "#919191",
            boxShadow: "inset 0 3px 0 0 #f1f1f1,inset 0 -4px 0 0 #ababab",
            padding: "13px 20px 15px",
            fontSize: "19px",
            ":hover": {
                outline: "0",
                paddingTop: "14px",
                paddingBottom: "14px",
                borderColor: "#7c7c7c",
                boxShadow: "inset 0 2px 0 0 #ababab,inset 0 -2px 0 0 #f1f1f1"
            },
            ":active": {
                outline: "0",
                paddingTop: "15px",
                paddingBottom: "13px",
                borderColor: "#636363",
                boxShadow: "inset 0 4px 0 0 #f1f1f1,inset 0 0 0 0 #fff"
            },
            ...props.$style
        })
    }, props.children);
};
/* harmony default export */ const components_MarketingButton = (MarketingButton);

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/menu/styled-components.js
var styled_components = __webpack_require__(80500);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/menu/stateful-menu.js + 5 modules
var stateful_menu = __webpack_require__(60433);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/popover/stateful-popover.js + 1 modules
var stateful_popover = __webpack_require__(20463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/popover/constants.js
var constants = __webpack_require__(65911);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/AccordionExpandIcon.tsx
var AccordionExpandIcon = __webpack_require__(29837);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/utils/index.ts
var utils = __webpack_require__(72919);
;// ../@gadgetinc/widgets/src/components/DropdownMenu.tsx







const ContextMenuListItem = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.c6)();
    return /*#__PURE__*/ react.createElement(styled_components/* StyledListItem */.HF, {
        ref: ref,
        ...props,
        $style: {
            ...props.item.divider ? {
                ...(0,utils/* expandBorderTop */.om)({
                    borderColor: $theme.colors.borderOpaque,
                    borderStyle: "solid",
                    borderWidth: "1px"
                }),
                transform: `translateY(${$theme.sizing.scale200})`,
                ...(0,utils/* paddingVertical */.kx)($theme.sizing.scale200),
                height: 0,
                pointerEvents: "none"
            } : {
                ...(0,utils/* paddingHorizontal */.iz)($theme.sizing.scale300),
                ...(0,utils/* paddingVertical */.kx)($theme.sizing.scale200),
                ...(0,utils/* marginHorizontal */.Lo)($theme.sizing.scale200),
                borderRadius: $theme.sizing.scale200
            }
        },
        "aria-label": props.item.ariaLabel ?? props["aria-label"]
    });
});
const DropdownMenu = (props)=>{
    const [menuOpen, setMenuOpen] = (0,react.useState)(false);
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    return /*#__PURE__*/ react.createElement(stateful_popover/* default */.A, {
        onOpen: ()=>setMenuOpen(true),
        onClose: ()=>setMenuOpen(false),
        placement: props.placement ?? constants/* PLACEMENT */.El.bottomRight,
        popoverMargin: 0,
        content: ({ close })=>/*#__PURE__*/ react.createElement(stateful_menu/* default */.A, {
                overrides: {
                    List: {
                        style: {
                            width: "140px",
                            overflow: "auto",
                            boxShadow: "none",
                            boxSizing: "content-box",
                            paddingTop: $theme.sizing.scale200,
                            paddingBottom: $theme.sizing.scale200
                        }
                    },
                    Option: {
                        props: {
                            overrides: {
                                ListItem: {
                                    component: ContextMenuListItem
                                }
                            }
                        }
                    },
                    ...props.overrides?.menu
                },
                items: props.items,
                onItemSelect: ({ item })=>{
                    item.onSelect();
                }
            }),
        overrides: {
            Body: {
                style: {
                    ...(0,utils/* marginVertical */.Pv)($theme.sizing.scale200)
                }
            }
        }
    }, /*#__PURE__*/ react.createElement(Row/* Row */.f, {
        $gap: $theme.sizing.scale500,
        className: css({
            paddingTop: $theme.sizing.scale200,
            paddingBottom: $theme.sizing.scale200,
            paddingLeft: $theme.sizing.scale300,
            paddingRight: $theme.sizing.scale300,
            ...(0,utils/* expandBorderRadii */.iw)($theme.borders.radius200),
            backgroundColor: menuOpen ? $theme.colors.alpha50 : undefined,
            boxShadow: menuOpen ? $theme.lighting.shadowButtonInset : undefined,
            cursor: "pointer",
            userSelect: "none",
            overflow: "hidden",
            ":hover": {
                backgroundColor: $theme.colors.alpha50
            },
            width: props.fullWidth ? "100%" : undefined,
            ...props.overrides?.triggerButton
        }),
        $align: "space-between"
    }, props.children, /*#__PURE__*/ react.createElement(AccordionExpandIcon/* AccordionExpandIcon */.e, {
        direction: props.overrideArrowDirection ?? (menuOpen ? "up" : "down"),
        $style: {
            color: $theme.colors.primary600
        }
    })));
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/styled-components.js
var icon_styled_components = __webpack_require__(50182);
;// ../@gadgetinc/widgets/src/icons/LogoutIcon.tsx


const LogoutIcon = (props)=>/*#__PURE__*/ react.createElement(icon_styled_components/* Svg */.B, {
        viewBox: "0 0 14 14",
        ...props
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M7.00015 0.600006C5.63752 0.600006 4.37791 1.03658 3.34494 1.76355C3.28762 1.80383 3.2388 1.85501 3.20127 1.91417C3.16373 1.97332 3.13821 2.03929 3.12617 2.1083C3.11413 2.17732 3.1158 2.24803 3.13108 2.3164C3.14637 2.38477 3.17497 2.44946 3.21525 2.50678C3.25554 2.56409 3.30672 2.61291 3.36587 2.65045C3.42503 2.68799 3.49099 2.71351 3.56001 2.72555C3.62902 2.73759 3.69974 2.73592 3.76811 2.72064C3.83648 2.70535 3.90117 2.67675 3.95848 2.63646C4.82311 2.02797 5.86464 1.66667 7.00015 1.66667C9.9519 1.66667 12.3335 4.04825 12.3335 7.00001C12.3335 9.95176 9.9519 12.3333 7.00015 12.3333C5.86464 12.3333 4.82311 11.972 3.95848 11.3635C3.84273 11.2822 3.69939 11.2501 3.56001 11.2745C3.42063 11.2988 3.29661 11.3775 3.21525 11.4932C3.13389 11.609 3.10185 11.7523 3.12617 11.8917C3.15049 12.0311 3.22919 12.1551 3.34494 12.2365C4.37791 12.9634 5.63752 13.4 7.00015 13.4C10.5284 13.4 13.4002 10.5283 13.4002 7.00001C13.4002 3.47176 10.5284 0.600006 7.00015 0.600006ZM2.72307 4.32813C2.58451 4.33226 2.453 4.39017 2.3564 4.48959L0.269941 6.57605C0.204601 6.62589 0.151662 6.69016 0.115255 6.76383C0.0788482 6.83751 0.0599582 6.9186 0.060059 7.00078C0.0601598 7.08297 0.0792489 7.16401 0.115836 7.2376C0.152424 7.31119 0.205521 7.37532 0.270983 7.42501L2.3564 9.51042C2.40554 9.56161 2.46441 9.60247 2.52954 9.63063C2.59468 9.65878 2.66478 9.67365 2.73573 9.67437C2.80669 9.67509 2.87707 9.66165 2.94277 9.63483C3.00846 9.60801 3.06814 9.56835 3.11832 9.51817C3.16849 9.468 3.20815 9.40832 3.23497 9.34262C3.26179 9.27693 3.27524 9.20654 3.27452 9.13559C3.27379 9.06463 3.25892 8.99453 3.23077 8.9294C3.20262 8.86426 3.16175 8.8054 3.11057 8.75626L1.88765 7.53334H7.53348C7.60416 7.53434 7.67432 7.52128 7.73991 7.49493C7.80549 7.46857 7.86518 7.42945 7.91551 7.37982C7.96584 7.3302 8.00581 7.27107 8.03309 7.20586C8.06037 7.14066 8.07441 7.07069 8.07441 7.00001C8.07441 6.92933 8.06037 6.85935 8.03309 6.79415C8.00581 6.72894 7.96584 6.66981 7.91551 6.62019C7.86518 6.57056 7.80549 6.53144 7.73991 6.50508C7.67432 6.47873 7.60416 6.46567 7.53348 6.46667H1.88765L3.11057 5.24376C3.18763 5.16884 3.24027 5.07239 3.26158 4.96705C3.2829 4.86171 3.27189 4.75238 3.23 4.6534C3.18811 4.55442 3.1173 4.47041 3.02684 4.41237C2.93638 4.35432 2.8305 4.32496 2.72307 4.32813Z",
        fill: "black"
    }));

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/typography/index.js
var typography = __webpack_require__(92908);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/compact.js
var compact = __webpack_require__(3794);
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/index.js + 13 modules
var es = __webpack_require__(10608);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-gravatar@2.6.3_react@0.0.0-experimental-4ead6b530/node_modules/react-gravatar/dist/index.js
var dist = __webpack_require__(45692);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// ./src/components/auth/UserDropdown.tsx








const UserDropdown = (0,es/* observer */.PA)((props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    const rootURL =  true ? "https://app.gadget.dev" : 0;
    return /*#__PURE__*/ react.createElement(Row/* Row */.f, {
        $gap: $theme.sizing.scale200,
        className: css({
            ...props.$style
        })
    }, /*#__PURE__*/ react.createElement(DropdownMenu, {
        fullWidth: true,
        items: compact_default()([
            {
                label: /*#__PURE__*/ react.createElement(Row/* Row */.f, {
                    $gap: $theme.sizing.scale400
                }, /*#__PURE__*/ react.createElement(LogoutIcon, null), "Logout"),
                onSelect: ()=>window.location.href = `${rootURL}/auth/logout`
            }
        ]),
        overrides: props.dropdownOverrides,
        overrideArrowDirection: props.overrideArrowDirection
    }, /*#__PURE__*/ react.createElement(Row/* Row */.f, {
        $gap: $theme.sizing.scale300
    }, /*#__PURE__*/ react.createElement((dist_default()), {
        email: props.userEmail,
        size: 16,
        rating: "pg",
        default: "identicon",
        className: css({
            ...(0,utils/* expandBorderRadii */.iw)("50%")
        })
    }), /*#__PURE__*/ react.createElement(typography/* LabelSmall */.ED, {
        $style: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        }
    }, props.userEmail))));
});

;// ./src/components/chrome/NotFound.tsx






const ErrorNavBar = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    const rootURL =  true ? "https://app.gadget.dev" : 0;
    const logoProps = {
        onClick: ()=>{
            window.location.href = `${rootURL}/auth/login`;
        },
        className: css({
            height: "46px",
            cursor: "pointer"
        })
    };
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            position: "absolute",
            top: "0",
            left: "0",
            height: 53,
            paddingBottom: "30px",
            paddingTop: "32px",
            paddingLeft: "40px",
            paddingRight: "40px"
        })
    }, props.logoOnly ? /*#__PURE__*/ react.createElement(GadgetLogo/* GadgetLogoMark */.V, logoProps) : /*#__PURE__*/ react.createElement(GadgetLogo/* GadgetLogoType */.w, logoProps), props.showButtons ? /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            alignContent: "center",
            alignItems: "center"
        })
    }, /*#__PURE__*/ react.createElement("a", {
        onClick: ()=>{
            window.location.href = `${rootURL}/auth/login`;
        },
        className: css({
            cursor: "pointer",
            fontFamily: "Inconsolata,monospace",
            fontWeight: 500,
            fontSize: $theme.sizing.scale650
        })
    }, "Login"), /*#__PURE__*/ react.createElement(components_MarketingButton, {
        $style: {
            height: "47px",
            marginLeft: "32px",
            backgroundColor: "#4242fc",
            borderColor: "#11118f",
            color: "#fff",
            padding: "11px 16px 13px 16px",
            fontSize: "18px",
            boxSizing: "border-box",
            boxShadow: "inset 0 3px 0 0 #7575ff,inset 0 -4px 0 0 #2b2bd9",
            ":hover": {
                paddingTop: "11px",
                paddingBottom: "11px",
                borderColor: "#11118f",
                boxShadow: "inset 0 2px 0 0 #2b2bd9, inset 0 -2px 0 0 #7575ff"
            },
            ":active": {
                paddingTop: "11px",
                paddingBottom: "11px",
                borderColor: "#030347",
                boxShadow: "inset 0 4px 0 0 #7575ff"
            }
        },
        onClick: ()=>{
            window.location.href = `${rootURL}/auth/signup`;
        }
    }, "Sign Up")) : /*#__PURE__*/ react.createElement("div", null, props.user && /*#__PURE__*/ react.createElement(UserDropdown, {
        userEmail: props.user
    })));
};
const NotFound = (props)=>{
    const [_, $theme] = (0,styled/* useStyletron */.c6)();
    const rootURL =  true ? "https://app.gadget.dev" : 0;
    return /*#__PURE__*/ react.createElement("div", {
        style: {
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden"
        }
    }, /*#__PURE__*/ react.createElement(Column/* Column */.V, {
        $gap: $theme.sizing.scale600,
        $style: {
            alignItems: "center"
        }
    }, /*#__PURE__*/ react.createElement(Row/* Row */.f, null, /*#__PURE__*/ react.createElement("span", {
        style: {
            ...$theme.typography.MonoHeadingSmall,
            fontSize: "24px",
            fontWeight: 700
        }
    }, "404: Page not found")), /*#__PURE__*/ react.createElement(Row/* Row */.f, null, /*#__PURE__*/ react.createElement(Button/* Button */.$n, {
        onClick: props.onBackToGadget ?? function() {
            window.location.href = rootURL;
        }
    }, "Back to Gadget"))));
};


/***/ }),

/***/ 25956:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: () => (/* binding */ EmptyStateCard)
/* harmony export */ });
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79638);
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72919);
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15530);
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36205);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27937);




const EmptyStateCard = (props)=>{
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .f, {
        $style: {
            alignItems: props.fullSize ? "stretch" : "center",
            justifyContent: "center",
            flex: "1",
            ...(0,_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_3__/* .marginUtil */ .nO)(props.noMargin ? 0 : $theme.sizing.scale300)
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_4__/* .Column */ .V, {
        $gap: props.$gap ?? $theme.sizing.scale800,
        $style: {
            ...(0,_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_3__/* .expandBorderRadii */ .iw)($theme.borders.radius200),
            ...(0,_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_3__/* .paddingUtil */ .Kl)(props.slimPadding ? $theme.sizing.scale800 : $theme.sizing.scale1000),
            ...(0,_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_3__/* .expandBaseWebBorder */ ._Y)({
                borderWidth: "1px",
                borderStyle: "dashed",
                borderColor: $theme.colors.borderOpaque
            }),
            alignItems: "center",
            justifyContent: "center",
            maxWidth: props.maxWidth,
            flex: props.fullSize ? 1 : undefined,
            ...props.$style
        }
    }, props.title && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Heading__WEBPACK_IMPORTED_MODULE_5__/* .Heading */ .D, {
        $style: {
            textAlign: "center"
        }
    }, props.title), "message" in props && props.message && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_6__/* .Body */ .n, {
        $style: {
            textAlign: "center"
        }
    }, props.message), "children" in props && props.children, props.actions && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .f, {
        $gap: $theme.sizing.scale500
    }, props.actions)));
};


/***/ }),

/***/ 73029:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   I: () => (/* binding */ PaymentRequiredCard)
/* harmony export */ });
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36129);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);
/* harmony import */ var _editor_EmptyStateCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25956);



const PaymentRequiredCard = ({ email })=>{
    const rootURL =  false ? 0 : "https://app.gadget.dev";
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_editor_EmptyStateCard__WEBPACK_IMPORTED_MODULE_1__/* .EmptyStateCard */ .X, {
        title: "Sorry, your application is unavailable.",
        message: "Your application will be unavailable until you upgrade to a paid plan.",
        actions: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .$n, {
            $as: "a",
            href: `${rootURL}/auth/billing#plans`,
            target: "_blank"
        }, "Upgrade plan")
    });
};


/***/ }),

/***/ 9701:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ../../node_modules/.pnpm/@sentry+react@7.15.0_react@0.0.0-experimental-4ead6b530/node_modules/@sentry/react/esm/sdk.js
var sdk = __webpack_require__(90927);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(81724);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/react-dom/index.js
var react_dom = __webpack_require__(23882);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/modal/Modal.tsx
var Modal = __webpack_require__(62783);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/utils/index.ts
var utils = __webpack_require__(72919);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/button/Button.tsx
var Button = __webpack_require__(36129);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/button/Link.tsx
var Link = __webpack_require__(68689);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/EditTheme.ts
var EditTheme = __webpack_require__(29196);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(89944);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/helpers/base-provider.js
var base_provider = __webpack_require__(59243);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/heading/heading-level.js
var heading_level = __webpack_require__(59964);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/typography/index.js
var typography = __webpack_require__(92908);
// EXTERNAL MODULE: ../../node_modules/.pnpm/styletron-react@6.0.2_react@0.0.0-experimental-4ead6b530/node_modules/styletron-react/dist/browser.es5.es.js
var browser_es5_es = __webpack_require__(63200);
// EXTERNAL MODULE: ./src/lib/styletronEngine.tsx
var styletronEngine = __webpack_require__(76880);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx@6.13.2/node_modules/mobx/dist/mobx.esm.js
var mobx_esm = __webpack_require__(97072);
;// ./src/components/edit/editor/panel/hooks.ts


let id = 0;
const semaphores = mobx_esm.observable.map();
const semaphoreTaken = (key)=>{
    return !!semaphores.get(key);
};
const useSemaphore = (key)=>{
    const me = react.useMemo(()=>id++, []);
    // we use a react state here so that we can set something and trigger a rerender
    const [hasSemaphore, setHasSemaphore] = react.useState(false);
    react.useEffect(()=>{
        if (semaphores.get(key) == undefined) {
            semaphores.set(key, me);
        }
        if (semaphores.get(key) == me) {
            setHasSemaphore(true);
        }
        return ()=>{
            if (semaphores.get(key) == me) {
                semaphores.delete(key);
            }
        };
    }, [
        key,
        me,
        setHasSemaphore
    ]);
    return hasSemaphore;
};

// EXTERNAL MODULE: ./src/components/chrome/DebugDisplay.tsx
var DebugDisplay = __webpack_require__(57907);
;// ./src/components/chrome/UserFacingErrorHandler.tsx
/* eslint-disable @typescript-eslint/no-misused-promises */ 










const ErrorUISemaphoreKey = "user-facing-error";
const ShowDeveloperErrorInfoKey = "show-dev-errors";
const ErrorModal = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    const hasSemaphore = useSemaphore(ErrorUISemaphoreKey); // only let one panel per node open at once
    const [isOpen, setIsOpen] = (0,react.useState)(true);
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const [isShowingErrorInfo, setShowErrorInfo] = (0,react.useState)( false || !!localStorage.getItem(ShowDeveloperErrorInfoKey));
    const close = ()=>setIsOpen(false);
    const refresh = ()=>{
        setIsLoading(true);
        window.location.reload();
    };
    const showErrorInfo = ()=>{
        setShowErrorInfo(true);
        localStorage.setItem(ShowDeveloperErrorInfoKey, "yes");
    };
    return /*#__PURE__*/ react.createElement(Modal/* Modal */.aF, {
        onClose: close,
        isOpen: isOpen && hasSemaphore,
        autoFocus: false,
        overrides: {
            Dialog: {
                style: {
                    width: "80vw",
                    height: "80vh",
                    display: "flex",
                    flexDirection: "column",
                    ...(0,utils/* expandBaseWebBorder */._Y)({
                        ...$theme.borders.border300,
                        borderColor: $theme.colors.negative300
                    })
                }
            }
        },
        title: /*#__PURE__*/ react.createElement("div", {
            style: {
                color: $theme.colors.negative500
            }
        }, "Oops, there's been an error."),
        footer: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Button/* Button */.$n, {
            kind: "tertiary",
            onClick: close
        }, "Close"), /*#__PURE__*/ react.createElement(Button/* Button */.$n, {
            isLoading: isLoading,
            onClick: refresh
        }, "Refresh"))
    }, /*#__PURE__*/ react.createElement(heading_level/* default */.Ay, null, "This application encountered an unexpected issue. The developer has been alerted. For now, you can close this dialog, or", " ", /*#__PURE__*/ react.createElement(Link/* Link */.N, {
        href: "#",
        onClick: refresh
    }, "refresh"), " ", "the page and try again.", /*#__PURE__*/ react.createElement("div", {
        className: css({
            marginTop: $theme.sizing.scale400
        })
    }, !isShowingErrorInfo && /*#__PURE__*/ react.createElement(Link/* Link */.N, {
        href: "#",
        onClick: showErrorInfo
    }, "Developers: Show Error Info"), isShowingErrorInfo && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(typography/* HeadingSmall */.MD, null, "Error Info"), /*#__PURE__*/ react.createElement("br", null), /*#__PURE__*/ react.createElement(typography/* HeadingXSmall */.en, null, "JS Error"), /*#__PURE__*/ react.createElement(DebugDisplay/* ErrorDisplay */.n, {
        error: props.error
    }), /*#__PURE__*/ react.createElement("br", null)))));
};
const installErrorHandler = ()=>{
    const showError = (error)=>{
        if (semaphoreTaken(ErrorUISemaphoreKey)) return;
        const root = document.createElement("div");
        document.body.appendChild(root);
        react_dom.unstable_createRoot(root).render(/*#__PURE__*/ react.createElement(react.StrictMode, null, /*#__PURE__*/ react.createElement(browser_es5_es/* Provider */.Kq, {
            value: styletronEngine/* styletronEngine */.L,
            debug: styletronEngine/* styletronDebug */.Q
        }, /*#__PURE__*/ react.createElement(base_provider/* default */.A, {
            theme: EditTheme/* EditLightTheme */.CG,
            overrides: {
                AppContainer: {
                    style: {
                        height: "100%"
                    }
                }
            }
        }, /*#__PURE__*/ react.createElement(ErrorModal, {
            error: error
        })))));
    };
    try {
        Error.stackTraceLimit = 50;
    } catch (e) {
    // Not all browsers support this so we don't care if it errors
    }
    window.addEventListener("error", (event)=>{
        showError(event.error);
    });
    window.addEventListener("unhandledrejection", (event)=>{
        let error;
        if (event == null || event.reason == null) {
            error = new Error("Unknown");
        } else {
            if (event.reason instanceof Error) {
                error = event.reason;
            } else {
                // A non-error was rejected, we don't have a trace :(
                // Look in your browser's devtools for more information
                error = new Error(event.reason);
            }
        }
        showError(error);
    });
};

// EXTERNAL MODULE: ./src/lib/flags.ts + 2 modules
var flags = __webpack_require__(90294);
// EXTERNAL MODULE: ./src/lib/global.css
var global = __webpack_require__(84341);
// EXTERNAL MODULE: ./src/components/edit/shared/PaymentRequiredCard.tsx
var PaymentRequiredCard = __webpack_require__(73029);
// EXTERNAL MODULE: ./src/components/chrome/NotFound.tsx + 4 modules
var NotFound = __webpack_require__(38683);
;// ./src/components/chrome/ApplicationUnavailable.tsx





const ApplicationUnavailable = ({ code, userEmail })=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    const paymentRequired = !!userEmail && code === "402";
    return /*#__PURE__*/ react.createElement(react.Fragment, null, userEmail && /*#__PURE__*/ react.createElement(NotFound/* ErrorNavBar */.H, {
        logoOnly: true,
        user: userEmail
    }), /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            ...(0,utils/* expandPadding */.ij)($theme.sizing.scale1600),
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            gap: $theme.sizing.scale800
        })
    }, paymentRequired ? /*#__PURE__*/ react.createElement(PaymentRequiredCard/* PaymentRequiredCard */.I, {
        email: userEmail
    }) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("div", {
        className: css({
            ...$theme.typography.MonoHeadingLarge
        })
    }, "Sorry, this application is unavailable."))));
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/styled-components.js
var styled_components = __webpack_require__(50182);
;// ../@gadgetinc/widgets/src/icons/ProhibitionHorizontalIcon.tsx


function ProhibitionHorizontalIcon(props) {
    return /*#__PURE__*/ react.createElement(styled_components/* Svg */.B, {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 1.6C11.52 1.6 14.4 4.48 14.4 8C14.4 11.52 11.52 14.4 8 14.4C4.48 14.4 1.6 11.52 1.6 8C1.6 4.48 4.48 1.6 8 1.6ZM3.2 7.2V8.8H12.8V7.2H3.2Z"
    }));
}

;// ./src/components/chrome/NoPermission.tsx





const NoPermission = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    // Performs a HEAD request at the current page to check if the user has permission to access the page every 5 seconds
    // If the user has permission, the page will automatically reload
    // If the user does not have permission, the page will stay as it is
    const MAX_RETRIES = 1000;
    const INTERVAL = 5000;
    const targetURL = window.location.href.split("?")[0];
    const attempts = (0,react.useRef)(0);
    (0,react.useEffect)(()=>{
        const interval = setInterval(()=>{
            if (attempts.current++ >= MAX_RETRIES || document.hidden) return;
            fetch(targetURL, {
                method: "HEAD"
            }).then((response)=>{
                if (response.ok) {
                    window.location.href = targetURL;
                }
            }).catch(()=>{
                return;
            });
        }, INTERVAL);
        return ()=>clearInterval(interval);
    }, [
        attempts,
        targetURL
    ]);
    const rootURL =  true ? "https://app.gadget.dev" : 0;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(NotFound/* ErrorNavBar */.H, {
        logoOnly: true,
        user: props.userEmail
    }), /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            flexDirection: "column",
            fontFamily: $theme.typography.ParagraphLarge.fontFamily
        })
    }, /*#__PURE__*/ react.createElement("div", {
        className: css({
            fontSize: $theme.sizing.scale700,
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: $theme.sizing.scale500
        })
    }, /*#__PURE__*/ react.createElement(ProhibitionHorizontalIcon, null), props.message ?? "You don’t have permission to view this app"), /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            marginTop: $theme.sizing.scale1000,
            marginBottom: $theme.sizing.scale600,
            gap: $theme.sizing.scale500
        })
    }, /*#__PURE__*/ react.createElement(Button/* Button */.$n, {
        onClick: ()=>window.location.href = `${rootURL}/auth/logout`,
        kind: "secondary"
    }, "Logout"), /*#__PURE__*/ react.createElement(Button/* Button */.$n, {
        onClick: ()=>history.back()
    }, "Go Back"))));
};
/* harmony default export */ const chrome_NoPermission = (NoPermission);

// EXTERNAL MODULE: ./src/components/edit/editor/EmptyStateCard.tsx
var EmptyStateCard = __webpack_require__(25956);
;// ./src/components/chrome/PausedEnvironment.tsx




const PausedEnvironment = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            ...(0,utils/* expandPadding */.ij)($theme.sizing.scale1600),
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            gap: $theme.sizing.scale800
        })
    }, /*#__PURE__*/ react.createElement(EmptyStateCard/* EmptyStateCard */.X, {
        title: "GGT_ENVIRONMENT_PAUSED",
        message: "Contact the developer to resume. If you’re the developer, unpause by opening the environment in the Gadget editor then refresh this page.",
        actions: /*#__PURE__*/ react.createElement(Button/* Button */.$n, {
            $as: "a",
            href: `https://${props.primaryDomain}/edit`,
            target: "_blank"
        }, "Unpause my app")
    }));
};

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Column.tsx
var Column = __webpack_require__(15530);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/typography/PageTitle.tsx
var PageTitle = __webpack_require__(4516);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/typography/Body.tsx
var Body = __webpack_require__(36205);
;// ./src/components/chrome/StillSettingUp.tsx



const StillSettingUp = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            padding: $theme.sizing.scale1600,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            gap: $theme.sizing.scale800
        })
    }, /*#__PURE__*/ react.createElement(Column/* Column */.V, {
        $gap: $theme.sizing.scale800
    }, /*#__PURE__*/ react.createElement(PageTitle/* PageTitle */.s, {
        $style: {
            fontSize: "32px",
            fontWeight: 700
        }
    }, "Still setting up..."), /*#__PURE__*/ react.createElement(Body/* Body */.n, null, "This app isn't available yet because it is still setting up. Please try again in a few moments.")));
};

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Row.tsx
var Row = __webpack_require__(79638);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/ExternalLinkIcon.tsx
var ExternalLinkIcon = __webpack_require__(22228);
;// ./src/components/chrome/UndeployedEnvironment.tsx




const UndeployedEnvironment = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    const docsURL =  true ? "https://docs.gadget.dev" : 0;
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            padding: $theme.sizing.scale1600,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            gap: $theme.sizing.scale800
        })
    }, /*#__PURE__*/ react.createElement(Column/* Column */.V, {
        $gap: $theme.sizing.scale800
    }, /*#__PURE__*/ react.createElement(PageTitle/* PageTitle */.s, {
        $style: {
            fontSize: "32px",
            fontWeight: 700
        }
    }, "This app hasn't been deployed to production."), /*#__PURE__*/ react.createElement(Row/* Row */.f, {
        $gap: $theme.sizing.scale600
    }, /*#__PURE__*/ react.createElement(Button/* Button */.$n, {
        $as: "a",
        kind: Button/* ButtonKind */.ZN.tertiary,
        target: "_blank",
        href: `${docsURL}/guides/deployment`,
        endEnhancer: /*#__PURE__*/ react.createElement(ExternalLinkIcon/* ExternalLinkIcon */.p, null)
    }, "Learn about deploying"))));
};

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/CircleCheckIcon.tsx
var CircleCheckIcon = __webpack_require__(87823);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/WarningIcon.tsx
var WarningIcon = __webpack_require__(71919);
// EXTERNAL MODULE: ./src/components/chrome/CenteredSpin.tsx
var CenteredSpin = __webpack_require__(57142);
;// ./src/components/chrome/InfoPoller.tsx


const InfoPoller = ()=>{
    (0,react.useEffect)(()=>{
        setTimeout(()=>window.location.reload(), 3000);
    }, []);
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(CenteredSpin/* CenteredSpin */.N, null));
};

;// ./src/components/render/InfoPage.tsx






const InfoPage = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    const iconStyles = {
        $size: 50,
        color: "black",
        backgroundColor: "transparent"
    };
    let iconComponent;
    switch(props.icon){
        case "Error":
            {
                iconComponent = /*#__PURE__*/ react.createElement(WarningIcon/* WarningIcon */.i, iconStyles);
                break;
            }
        case "Success":
            {
                iconComponent = /*#__PURE__*/ react.createElement(CircleCheckIcon/* CircleCheckIcon */.y, iconStyles);
                break;
            }
    }
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            ...(0,utils/* expandPadding */.ij)($theme.sizing.scale1600),
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            gap: $theme.sizing.scale800
        })
    }, /*#__PURE__*/ react.createElement("div", null, iconComponent), props.message.split("\n").map((text, index)=>/*#__PURE__*/ react.createElement("div", {
            key: index,
            className: css({
                ...$theme.typography.MonoHeadingLarge
            }),
            dangerouslySetInnerHTML: {
                __html: text
            }
        })), props.userEmail && /*#__PURE__*/ react.createElement("a", {
        href: props.logsLink,
        className: css({
            ...$theme.typography.MonoHeadingLarge
        })
    }, props.logsLink), props.poll && /*#__PURE__*/ react.createElement(InfoPoller, null));
};

;// ./src/components/render/InfoApp.tsx















const InfoAppContainer = ()=>{
    const { icon, message, logsLink, code, ggtCode, poll, primaryDomain, userEmail } = window.GadgetInfo;
    if (code === "404") {
        return /*#__PURE__*/ react.createElement(NotFound/* NotFound */.M, null);
    } else if (ggtCode && ggtCode === "GGT_UNDEPLOYED_ENVIRONMENT" && primaryDomain) {
        return /*#__PURE__*/ react.createElement(UndeployedEnvironment, {
            primaryDomain: primaryDomain
        });
    } else if (ggtCode && ggtCode === "GGT_STILL_SETTING_UP" && primaryDomain) {
        return /*#__PURE__*/ react.createElement(StillSettingUp, {
            primaryDomain: primaryDomain
        });
    } else if (ggtCode && ggtCode === "GGT_ENVIRONMENT_PAUSED" && primaryDomain) {
        return /*#__PURE__*/ react.createElement(PausedEnvironment, {
            primaryDomain: primaryDomain
        });
    } else if (code === "403") {
        return /*#__PURE__*/ react.createElement(chrome_NoPermission, {
            userEmail: userEmail,
            message: message
        });
    } else if (code === "402" || code === "423") {
        return /*#__PURE__*/ react.createElement(ApplicationUnavailable, {
            code: code,
            userEmail: userEmail
        });
    } else {
        return /*#__PURE__*/ react.createElement(InfoPage, {
            icon: icon,
            message: message,
            poll: poll,
            logsLink: logsLink,
            userEmail: userEmail
        });
    }
};
const InfoApp = ()=>/*#__PURE__*/ react.createElement(flags/* FlagsProvider */.nT, {
        flags: flags/* CurrentFlags */.B2
    }, /*#__PURE__*/ react.createElement(browser_es5_es/* Provider */.Kq, {
        value: styletronEngine/* styletronEngine */.L,
        debug: styletronEngine/* styletronDebug */.Q
    }, /*#__PURE__*/ react.createElement(base_provider/* default */.A, {
        theme: EditTheme/* EditLightTheme */.CG,
        overrides: {
            AppContainer: {
                style: {
                    height: "100%"
                }
            }
        }
    }, /*#__PURE__*/ react.createElement(InfoAppContainer, null))));

;// ./src/info.tsx







if (true) {
    sdk/* init */.T({
        dsn: "https://d043e398111b4b64bb3ba9038b2b3555@o250689.ingest.sentry.io/5352810"
    });
}
installErrorHandler();
react_dom.unstable_createRoot((0,utils/* assert */.vA)(document.getElementById("root"))).render(/*#__PURE__*/ react.createElement(react.StrictMode, null, /*#__PURE__*/ react.createElement(InfoApp, null)));


/***/ }),

/***/ 90294:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  B2: () => (/* binding */ CurrentFlags),
  lN: () => (/* binding */ Flag),
  nT: () => (/* binding */ FlagsProvider),
  _P: () => (/* binding */ useFlag),
  D0: () => (/* binding */ useFlags)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/flag@4.4.0_@types+react-dom@17.0.5_@types+react@17.0.4_react-dom@0.0.0-experimental-4ead6b530_5wujmyu4zyhz3ob3w23lepq2am/node_modules/flag/build/index.js
var build = __webpack_require__(51331);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/merge.js
var merge = __webpack_require__(12495);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx@6.13.2/node_modules/mobx/dist/mobx.esm.js
var mobx_esm = __webpack_require__(97072);
;// ../state-trees/src/assistant/index.ts
const MainPromptVersion = "main";
const NextPromptVersion = "next";
const PromptVersions = [
    MainPromptVersion,
    NextPromptVersion
];

// EXTERNAL MODULE: ../state-trees/src/type-system/FieldType.ts
var FieldType = __webpack_require__(21687);
;// ../state-trees/src/GadgetFlags.ts



/** Default flag state used for tests in state-trees and web */ const TestFlagDefaultState = {
    features: {
        fieldTypes: {
            [FieldType/* FieldType */.PU.Computed]: false,
            [FieldType/* FieldType */.PU.Color]: false,
            [FieldType/* FieldType */.PU.Money]: false
        },
        darkMode: false,
        ideJSErrorChecking: false,
        actionsAsCode: true,
        fileBasedActions: true,
        computedViews: true,
        actionsExplainerPopup: false,
        stateInActionCode: false,
        codeMirrorShowAllErrors: false,
        codeMirrorHideAllErrors: false,
        shopifyCustomerAuthentication: false,
        elasticsearchSearchAPI: true,
        computedFieldFiltering: true,
        editorAssistant: true,
        assistantReviewMode: "off",
        assistantManagesTodos: false,
        internalTools: true,
        stringEndsWithFilter: true,
        summonApps: false,
        scaffoldApps: false,
        hobbyUnrestricted: false,
        tabbedLeftNav: false,
        editorAIAutocomplete: false,
        editorTerminal: true,
        automaticPausing: false,
        runShopifyAppDeploy: false
    },
    internal: {
        eluLimiterMode: "off",
        canarySandbox: false,
        stagingLoki: false,
        rateLimitMode: "enforce",
        shopifyWebhookLoopDetection: false,
        dedicatedColumnsStrategy: true,
        apiKeysInBrowserClients: true,
        throttleExchange: false,
        edgeFrameworkVersion: false,
        blackholeWebhooks: false,
        selectFrameworkVersionOnCreate: false,
        useTemporalBlueCluster: false,
        loadTypesInLanguageServer: false,
        showProblemsInEditor: true,
        cloudflareTurnstile: false,
        usePreparedStatement: false,
        newEnvironmentShard: "main",
        defaultDevelopmentToSharedJSON: true,
        useSpotForSandbox: false,
        searchIndex: true,
        aiPromptVersion: MainPromptVersion,
        assistantModelOverrides: {
            topLevelAgent: "codebase-default",
            baseFastSimple: "codebase-default",
            baseReasoning: "codebase-default",
            dataModeller: "codebase-default",
            codeGenerator: "codebase-default",
            codeEvaluator: "codebase-default",
            changeSelector: "codebase-default",
            codeDiffApplier: "codebase-default",
            summarizer: "codebase-default"
        }
    }
};
const ClientSideDefaultFlags = merge_default()({}, TestFlagDefaultState, {});

;// ./src/lib/flags.ts





const { FlagsProvider, Flag, useFlag, useFlags } = (0,build/* default */.Ay)();
const CurrentFlags = (0,mobx_esm.observable)(typeof window === "undefined" ? ClientSideDefaultFlags : window.GadgetFlags);
if (typeof window !== "undefined") {
    /** Utility for setting flag values in tests */ window.mockFlags = (newFlags)=>{
        merge_default()(CurrentFlags, newFlags);
    };
}


/***/ }),

/***/ 76880:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L: () => (/* binding */ styletronEngine),
/* harmony export */   Q: () => (/* binding */ styletronDebug)
/* harmony export */ });
/* harmony import */ var styletron_engine_monolithic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23252);
/* harmony import */ var styletron_engine_monolithic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89338);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63200);


const getHydrations = ()=>document.getElementsByClassName("_styletron_hydrate_");
const stylePrefix = "g-";
const styletronEngine = typeof window === "undefined" ? new styletron_engine_monolithic__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A({
    prefix: stylePrefix
}) : new styletron_engine_monolithic__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A({
    hydrate: getHydrations(),
    prefix: stylePrefix
});
const shouldNotDebug =  true || 0;
const styletronDebug = shouldNotDebug ? undefined : new styletron_react__WEBPACK_IMPORTED_MODULE_2__/* .DebugEngine */ .Cd();


/***/ }),

/***/ 31325:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ _assertThisInitialized)
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),

/***/ 15318:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ay: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony exports __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, lazy, loadableReady */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55207);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61396);
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31325);
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39191);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4674);







/* eslint-disable import/prefer-default-export */
function invariant(condition, message) {
  if (condition) return;
  var error = new Error("loadable: " + message);
  error.framesToPop = 1;
  error.name = 'Invariant Violation';
  throw error;
}
function warn(message) {
  // eslint-disable-next-line no-console
  console.warn("loadable: " + message);
}

var Context = /*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0__.createContext();

var LOADABLE_REQUIRED_CHUNKS_KEY = '__LOADABLE_REQUIRED_CHUNKS__';
function getRequiredChunkKey(namespace) {
  return "" + namespace + LOADABLE_REQUIRED_CHUNKS_KEY;
}

var sharedInternals = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getRequiredChunkKey: getRequiredChunkKey,
  invariant: invariant,
  Context: Context
});

var LOADABLE_SHARED = {
  initialChunks: {}
};

var STATUS_PENDING = 'PENDING';
var STATUS_RESOLVED = 'RESOLVED';
var STATUS_REJECTED = 'REJECTED';

function resolveConstructor(ctor) {
  if (typeof ctor === 'function') {
    return {
      requireAsync: ctor,
      resolve: function resolve() {
        return undefined;
      },
      chunkName: function chunkName() {
        return undefined;
      }
    };
  }

  return ctor;
}

var withChunkExtractor = function withChunkExtractor(Component) {
  var LoadableWithChunkExtractor = function LoadableWithChunkExtractor(props) {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Context.Consumer, null, function (extractor) {
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, Object.assign({
        __chunkExtractor: extractor
      }, props));
    });
  };

  if (Component.displayName) {
    LoadableWithChunkExtractor.displayName = Component.displayName + "WithChunkExtractor";
  }

  return LoadableWithChunkExtractor;
};

var identity = function identity(v) {
  return v;
};

function createLoadable(_ref) {
  var _ref$defaultResolveCo = _ref.defaultResolveComponent,
      defaultResolveComponent = _ref$defaultResolveCo === void 0 ? identity : _ref$defaultResolveCo,
      _render = _ref.render,
      onLoad = _ref.onLoad;

  function loadable(loadableConstructor, options) {
    if (options === void 0) {
      options = {};
    }

    var ctor = resolveConstructor(loadableConstructor);
    var cache = {};
    /**
     * Cachekey represents the component to be loaded
     * if key changes - component has to be reloaded
     * @param props
     * @returns {null|Component}
     */

    function _getCacheKey(props) {
      if (options.cacheKey) {
        return options.cacheKey(props);
      }

      if (ctor.resolve) {
        return ctor.resolve(props);
      }

      return 'static';
    }
    /**
     * Resolves loaded `module` to a specific `Component
     * @param module
     * @param props
     * @param Loadable
     * @returns Component
     */


    function resolve(module, props, Loadable) {
      var Component = options.resolveComponent ? options.resolveComponent(module, props) : defaultResolveComponent(module); // FIXME: suppressed due to https://github.com/gregberge/loadable-components/issues/990
      // if (options.resolveComponent && !ReactIs.isValidElementType(Component)) {
      //   throw new Error(
      //     `resolveComponent returned something that is not a React component!`,
      //   )
      // }

      hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__(Loadable, Component, {
        preload: true
      });
      return Component;
    }

    var cachedLoad = function cachedLoad(props) {
      var cacheKey = _getCacheKey(props);

      var promise = cache[cacheKey];

      if (!promise || promise.status === STATUS_REJECTED) {
        promise = ctor.requireAsync(props);
        promise.status = STATUS_PENDING;
        cache[cacheKey] = promise;
        promise.then(function () {
          promise.status = STATUS_RESOLVED;
        }, function (error) {
          console.error('loadable-components: failed to asynchronously load component', {
            fileName: ctor.resolve(props),
            chunkName: ctor.chunkName(props),
            error: error ? error.message : error
          });
          promise.status = STATUS_REJECTED;
        });
      }

      return promise;
    };

    var InnerLoadable =
    /*#__PURE__*/
    function (_React$Component) {
      (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(InnerLoadable, _React$Component);

      InnerLoadable.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        var cacheKey = _getCacheKey(props);

        return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)({}, state, {
          cacheKey: cacheKey,
          // change of a key triggers loading state automatically
          loading: state.loading || state.cacheKey !== cacheKey
        });
      };

      function InnerLoadable(props) {
        var _this;

        _this = _React$Component.call(this, props) || this;
        _this.state = {
          result: null,
          error: null,
          loading: true,
          cacheKey: _getCacheKey(props)
        };
        invariant(!props.__chunkExtractor || ctor.requireSync, 'SSR requires `@loadable/babel-plugin`, please install it'); // Server-side

        if (props.__chunkExtractor) {
          // This module has been marked with no SSR
          if (options.ssr === false) {
            return (0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(_this);
          } // We run load function, we assume that it won't fail and that it
          // triggers a synchronous loading of the module


          ctor.requireAsync(props)["catch"](function () {
            return null;
          }); // So we can require now the module synchronously

          _this.loadSync();

          props.__chunkExtractor.addChunk(ctor.chunkName(props));

          return (0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(_this);
        } // Client-side with `isReady` method present (SSR probably)
        // If module is already loaded, we use a synchronous loading
        // Only perform this synchronous loading if the component has not
        // been marked with no SSR, else we risk hydration mismatches


        if (options.ssr !== false && ( // is ready - was loaded in this session
        ctor.isReady && ctor.isReady(props) || // is ready - was loaded during SSR process
        ctor.chunkName && LOADABLE_SHARED.initialChunks[ctor.chunkName(props)])) {
          _this.loadSync();
        }

        return _this;
      }

      var _proto = InnerLoadable.prototype;

      _proto.componentDidMount = function componentDidMount() {
        this.mounted = true; // retrieve loading promise from a global cache

        var cachedPromise = this.getCache(); // if promise exists, but rejected - clear cache

        if (cachedPromise && cachedPromise.status === STATUS_REJECTED) {
          this.setCache();
        } // component might be resolved synchronously in the constructor


        if (this.state.loading) {
          this.loadAsync();
        }
      };

      _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        // Component has to be reloaded on cacheKey change
        if (prevState.cacheKey !== this.state.cacheKey) {
          this.loadAsync();
        }
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
      };

      _proto.safeSetState = function safeSetState(nextState, callback) {
        if (this.mounted) {
          this.setState(nextState, callback);
        }
      }
      /**
       * returns a cache key for the current props
       * @returns {Component|string}
       */
      ;

      _proto.getCacheKey = function getCacheKey() {
        return _getCacheKey(this.props);
      }
      /**
       * access the persistent cache
       */
      ;

      _proto.getCache = function getCache() {
        return cache[this.getCacheKey()];
      }
      /**
       * sets the cache value. If called without value sets it as undefined
       */
      ;

      _proto.setCache = function setCache(value) {
        if (value === void 0) {
          value = undefined;
        }

        cache[this.getCacheKey()] = value;
      };

      _proto.triggerOnLoad = function triggerOnLoad() {
        var _this2 = this;

        if (onLoad) {
          setTimeout(function () {
            onLoad(_this2.state.result, _this2.props);
          });
        }
      }
      /**
       * Synchronously loads component
       * target module is expected to already exists in the module cache
       * or be capable to resolve synchronously (webpack target=node)
       */
      ;

      _proto.loadSync = function loadSync() {
        // load sync is expecting component to be in the "loading" state already
        // sounds weird, but loading=true is the initial state of InnerLoadable
        if (!this.state.loading) return;

        try {
          var loadedModule = ctor.requireSync(this.props);
          var result = resolve(loadedModule, this.props, Loadable);
          this.state.result = result;
          this.state.loading = false;
        } catch (error) {
          console.error('loadable-components: failed to synchronously load component, which expected to be available', {
            fileName: ctor.resolve(this.props),
            chunkName: ctor.chunkName(this.props),
            error: error ? error.message : error
          });
          this.state.error = error;
        }
      }
      /**
       * Asynchronously loads a component.
       */
      ;

      _proto.loadAsync = function loadAsync() {
        var _this3 = this;

        var promise = this.resolveAsync();
        promise.then(function (loadedModule) {
          var result = resolve(loadedModule, _this3.props, Loadable);

          _this3.safeSetState({
            result: result,
            loading: false
          }, function () {
            return _this3.triggerOnLoad();
          });
        })["catch"](function (error) {
          return _this3.safeSetState({
            error: error,
            loading: false
          });
        });
        return promise;
      }
      /**
       * Asynchronously resolves(not loads) a component.
       * Note - this function does not change the state
       */
      ;

      _proto.resolveAsync = function resolveAsync() {
        var _this$props = this.props,
            __chunkExtractor = _this$props.__chunkExtractor,
            forwardedRef = _this$props.forwardedRef,
            props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(_this$props, ["__chunkExtractor", "forwardedRef"]);

        return cachedLoad(props);
      };

      _proto.render = function render() {
        var _this$props2 = this.props,
            forwardedRef = _this$props2.forwardedRef,
            propFallback = _this$props2.fallback,
            __chunkExtractor = _this$props2.__chunkExtractor,
            props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(_this$props2, ["forwardedRef", "fallback", "__chunkExtractor"]);

        var _this$state = this.state,
            error = _this$state.error,
            loading = _this$state.loading,
            result = _this$state.result;

        if (options.suspense) {
          var cachedPromise = this.getCache() || this.loadAsync();

          if (cachedPromise.status === STATUS_PENDING) {
            throw this.loadAsync();
          }
        }

        if (error) {
          throw error;
        }

        var fallback = propFallback || options.fallback || null;

        if (loading) {
          return fallback;
        }

        return _render({
          fallback: fallback,
          result: result,
          options: options,
          props: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)({}, props, {
            ref: forwardedRef
          })
        });
      };

      return InnerLoadable;
    }(react__WEBPACK_IMPORTED_MODULE_0__.Component);

    var EnhancedInnerLoadable = withChunkExtractor(InnerLoadable);
    var Loadable = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(EnhancedInnerLoadable, Object.assign({
        forwardedRef: ref
      }, props));
    });
    Loadable.displayName = 'Loadable'; // In future, preload could use `<link rel="preload">`

    Loadable.preload = function (props) {
      Loadable.load(props);
    };

    Loadable.load = function (props) {
      return cachedLoad(props);
    };

    return Loadable;
  }

  function lazy(ctor, options) {
    return loadable(ctor, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)({}, options, {
      suspense: true
    }));
  }

  return {
    loadable: loadable,
    lazy: lazy
  };
}

function defaultResolveComponent(loadedModule) {
  // eslint-disable-next-line no-underscore-dangle
  return loadedModule.__esModule ? loadedModule["default"] : loadedModule["default"] || loadedModule;
}

/* eslint-disable no-use-before-define, react/no-multi-comp */

var _createLoadable =
/*#__PURE__*/
createLoadable({
  defaultResolveComponent: defaultResolveComponent,
  render: function render(_ref) {
    var Component = _ref.result,
        props = _ref.props;
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, props);
  }
}),
    loadable = _createLoadable.loadable,
    lazy = _createLoadable.lazy;

/* eslint-disable no-use-before-define, react/no-multi-comp */

var _createLoadable$1 =
/*#__PURE__*/
createLoadable({
  onLoad: function onLoad(result, props) {
    if (result && props.forwardedRef) {
      if (typeof props.forwardedRef === 'function') {
        props.forwardedRef(result);
      } else {
        props.forwardedRef.current = result;
      }
    }
  },
  render: function render(_ref) {
    var result = _ref.result,
        props = _ref.props;

    if (props.children) {
      return props.children(result);
    }

    return null;
  }
}),
    loadable$1 = _createLoadable$1.loadable,
    lazy$1 = _createLoadable$1.lazy;

/* eslint-disable no-underscore-dangle, camelcase */
var BROWSER = typeof window !== 'undefined';
function loadableReady(done, _temp) {
  if (done === void 0) {
    done = function done() {};
  }

  var _ref = _temp === void 0 ? {} : _temp,
      _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === void 0 ? '' : _ref$namespace,
      _ref$chunkLoadingGlob = _ref.chunkLoadingGlobal,
      chunkLoadingGlobal = _ref$chunkLoadingGlob === void 0 ? '__LOADABLE_LOADED_CHUNKS__' : _ref$chunkLoadingGlob;

  if (!BROWSER) {
    warn('`loadableReady()` must be called in browser only');
    done();
    return Promise.resolve();
  }

  var requiredChunks = null;

  if (BROWSER) {
    var id = getRequiredChunkKey(namespace);
    var dataElement = document.getElementById(id);

    if (dataElement) {
      requiredChunks = JSON.parse(dataElement.textContent);
      var extElement = document.getElementById(id + "_ext");

      if (extElement) {
        var _JSON$parse = JSON.parse(extElement.textContent),
            namedChunks = _JSON$parse.namedChunks;

        namedChunks.forEach(function (chunkName) {
          LOADABLE_SHARED.initialChunks[chunkName] = true;
        });
      } else {
        // version mismatch
        throw new Error('loadable-component: @loadable/server does not match @loadable/component');
      }
    }
  }

  if (!requiredChunks) {
    warn('`loadableReady()` requires state, please use `getScriptTags` or `getScriptElements` server-side');
    done();
    return Promise.resolve();
  }

  var resolved = false;
  return new Promise(function (resolve) {
    window[chunkLoadingGlobal] = window[chunkLoadingGlobal] || [];
    var loadedChunks = window[chunkLoadingGlobal];
    var originalPush = loadedChunks.push.bind(loadedChunks);

    function checkReadyState() {
      if (requiredChunks.every(function (chunk) {
        return loadedChunks.some(function (_ref2) {
          var chunks = _ref2[0];
          return chunks.indexOf(chunk) > -1;
        });
      })) {
        if (!resolved) {
          resolved = true;
          resolve();
        }
      }
    }

    loadedChunks.push = function () {
      originalPush.apply(void 0, arguments);
      checkReadyState();
    };

    checkReadyState();
  }).then(done);
}

/* eslint-disable no-underscore-dangle */
var loadable$2 = loadable;
loadable$2.lib = loadable$1;
var lazy$2 = lazy;
lazy$2.lib = lazy$1;
var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (/* unused pure expression or super */ null && (sharedInternals));

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (loadable$2);



/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [1960,3343,3643,2160,7112,6483,2483,2619,1806,682,3895], () => (__webpack_exec__(9701)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);